/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './exitForm.component.css';
import PriorAuthorizationService from '../../services/PriorAuthorization/priorauthorization.service';
import { PriorAuthorizationDomainContext } from '../../context/ctxPriorAuthorizationDomain';
import ITokenService from '../../interfaces/ITokenService';
import { appInsights } from '../../AppInsights';

type AppProps = {
  tokenService: ITokenService,
  sessionType: string,
  skipSavePriorAuthorization: boolean
};

const ExitFormModal: React.FC<AppProps> = (props: AppProps) => {
  const [show, setShow] = useState<boolean>(false);

  const { priorAuthorizationDomain } = useContext(PriorAuthorizationDomainContext);

  const handleClose = (): void => setShow(false);
  const handleShow = (): void => setShow(true);

  const saveAndExit = () => {
    // Check if we need to skip saving PA
    // This logic is need to for additional clinical document upload compoenent
    if (props.skipSavePriorAuthorization) {
      props.tokenService.clearSession(props.sessionType).then(() => {
        window.opener = null;
        window.open('', '_self');
        window.close();
      })
        .catch((error) => {
          console.error('clearSession error on exit modal save: ', error);
          appInsights.trackTrace({ message: 'clearSession error on exit modal save:' });
          appInsights.trackException({ exception: error });
        })
        .finally(() => {
          setShow(false);
        });
    } else {
      PriorAuthorizationService.savePriorAuthorization(priorAuthorizationDomain)
        .then(() => {
          props.tokenService.clearSession(props.sessionType).then(() => {
            window.opener = null;
            window.open('', '_self');
            window.close();
          });
        })
        .catch((error) => {
          console.error('PriorAuthSave error on exit modal save: ', error);
          appInsights.trackTrace({ message: 'PriorAuthSave error on exit modal save: ' });
          appInsights.trackException({ exception: error });
        })
        .finally(() => {
          setShow(false);
        });
    }
  };

  return (
    <>
      <p><a type="button" data-testid="exit-form-id" id="modal-show-button" className="font-size-sm" onClick={handleShow}>Exit Form</a></p>

      <Modal show={show} onHide={handleClose}>
        <div className="modal fade show exitFormBase" data-testid="exitModal" id="exitModal" tabIndex={-1} role="dialog" data-backdrop="static" aria-modal="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header shadow-sm">
                <h5 id="title-of-modal" data-testid="modalTitle" className="modal-title">Are you sure you want to exit?</h5>
                <button type="button" onClick={handleClose} className="close" id="closeIcon" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" data-testid="modalBody">
                {props.skipSavePriorAuthorization
                  ? <p>Are you sure you want to exit this form?  Any documentation that has not been properly uploaded will not be saved.</p>
                  : <p>You are about to save and exit this form.  Saved requests must be completed within 24 business hours.</p>}

              </div>
              <div id="modal-footer-id" className="modal-footer border-0">
                <button id="cancel-button" data-testid="cancelButton" type="button" data-dismiss="modal" onClick={handleClose} aria-label="Close" className="btn btn-sm btn-secondary mr-2">Cancel</button>
                <a id="primary-exit-button" data-testid="saveAndExitButton" type="button" data-dismiss="modal" onClick={saveAndExit} aria-label="Save and Exit" className="btn btn-sm btn-primary mr-2">
                  {props.skipSavePriorAuthorization ? 'Exit' : 'Save and Exit'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExitFormModal;
